import { render } from "./EcommercePage.vue?vue&type=template&id=3e38d594&ts=true"
import script from "./EcommercePage.vue?vue&type=script&lang=ts"
export * from "./EcommercePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__